import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { CATEGORIES } from "../../data/destinations";

const catLabel = (id) => CATEGORIES.find((c) => c.id === id)?.label ?? id;

const FALLBACK = {
  travel: "https://images.unsplash.com/photo-1533676802871-eca1ae998cd5?q=80&w=1200&auto=format&fit=crop",
  yoga: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=1200&auto=format&fit=crop",
  wellness: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?q=80&w=1200&auto=format&fit=crop",
  adventure: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=1200&auto=format&fit=crop",
};

export const DestinationCard = ({ item, index = 0 }) => {
  return (
    <Link
      data-testid={`destination-card-${item.id}`}
      to={`/escape/${item.id}`}
      className="group block fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="card-img-wrap img-gradient-overlay relative aspect-[3/4] w-full bg-brand-bg2">
        <img
          src={item.image}
          alt={`${item.title}, ${item.country}`}
          loading="lazy"
          onError={(e) => { if (e.target.src !== FALLBACK[item.category]) e.target.src = FALLBACK[item.category]; }}
          className="card-img absolute inset-0 h-full w-full object-cover"
        />
        {/* top badges */}
        <div className="absolute inset-x-0 top-0 z-10 flex items-start justify-between p-4">
          <span
            data-testid={`card-category-${item.id}`}
            className="overline rounded-full bg-white/90 px-3 py-1.5 text-brand-ink"
            style={{ fontSize: "0.6rem" }}
          >
            {catLabel(item.category)}
          </span>
          <span className="inline-flex items-center gap-1 rounded-full bg-black/30 px-3 py-1.5 text-[11px] font-medium text-white backdrop-blur-md">
            <MapPin size={12} /> {item.country}
          </span>
        </div>

        {/* bottom title overlay */}
        <div className="absolute inset-x-0 bottom-0 z-10 p-5">
          <h3 className="font-display text-2xl leading-tight text-white md:text-3xl">
            {item.title}
          </h3>
          <p className="mt-1 line-clamp-2 text-sm text-white/85">
            {item.blurb}
          </p>
        </div>
      </div>

      {/* meta row */}
      <div className="mt-4 flex items-center justify-between px-1">
        <div className="text-sm text-brand-inkSoft">
          <span className="font-medium text-brand-ink">{item.duration}</span>
          <span className="mx-2 text-brand-line">·</span>
          <span>from {item.priceFrom}</span>
        </div>
        <div className="inline-flex items-center gap-1.5 text-sm font-medium text-brand-ink">
          <span data-testid={`card-partner-${item.id}`} className="link-underline">
            View 20 packages
          </span>
          <ArrowUpRight
            size={16}
            className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
          />
        </div>
      </div>
    </Link>
  );
};

export default DestinationCard;
